function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "car_2");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "car_2"
}, /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 2.54,
  y1: 33.44,
  x2: 7.15,
  y2: 33.44
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  cx: 48.14,
  cy: 41.63,
  rx: 4.08,
  ry: 3.85
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  cx: 14,
  cy: 41.63,
  rx: 4.08,
  ry: 3.85
}), /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 18.08,
  y1: 41.63,
  x2: 44.05,
  y2: 41.63
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M9.91,41.63H5.82C4,41.63,2.54,40.44,2.54,39v-7a3.4,3.4,0,0,1,3.4-3.4h7.44a3.35,3.35,0,0,0,2.25-.86l9.07-8.12a4,4,0,0,1,2.68-1H46.1a2.2,2.2,0,0,1,1.86,1l4.87,7.8A2.51,2.51,0,0,0,55,28.53h3.74a2.09,2.09,0,0,1,2.19,2V39A2.81,2.81,0,0,1,58,41.63H52.22"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M13.4,28.53H44.5a1.27,1.27,0,0,0,1.11-1.85l-4.17-8.17"
}), /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 33.56,
  y1: 18.52,
  x2: 33.56,
  y2: 28.53
}));

var SvgCar2 = function SvgCar2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCar2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/car_2.43db3a31.svg";
export { ForwardRef as ReactComponent };